<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="SquashActor"
    title="Squash Actor"
    submit-name="Squash"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <p class="text-gray-700 mb-4">
      Squashing an Actor moves all its children's contents (Topics and Sources)
      into the Actor, then removes all its children.
    </p>
    <img src="./images/examples/squash.jpg" class="mx-auto mb-6 border" />
    <p class="text-gray-700 mb-2">
      Are you sure you want to squash the actor
      <span :class="'text-' + selectedActor.color">{{
        selectedActor.name
      }}</span
      >?
    </p>
    <lm-checkbox v-model="checked" label="Squash this actor" />
    <transition name="fade">
      <span v-show="checkError" class="block mt-2 text-xs text-error">{{
        checkError
      }}</span>
    </transition>
    <div class="flex items-center mt-5 px-2 py-4 border">
      <lm-icon icon="warning" class="text-error mr-3" />
      <p class="m-0 text-gray-700">
        Please note: this process cannot be undone.
      </p>
    </div>
  </form-modal>
</template>

<script>
import LmCheckbox from '@/components/form/LmCheckbox'
import LmIcon from '@/components/ui/LmIcon'
import EventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'
import {AlertMessages, Events, Modal} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'

export default {
  name: 'ModalSquashActor',
  components: {
    LmCheckbox,
    LmIcon,
    FormModal
  },
  data() {
    return {
      Events,
      modalName: Modal.SQUASH_ACTOR,
      modalRef: null,
      checked: false,
      checkError: ''
    }
  },
  computed: mapGetters(['selectedActor']),
  watch: {
    checked(b) {
      if (b) this.checkError = ''
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (this.checked) {
        this.$store
          .dispatch('squashActor')
          .then(() => {
            this.$store.dispatch('loadActorStats')
            this.modalRef.submitSuccess()
          })
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.checkError = `* Check this if you really want to perform this action.`
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, AlertMessages.ACTOR_SQUASHED)
      }
    }
  }
}
</script>
